import React, {Component} from 'react'
import {connect} from 'react-redux'
import querystring from 'query-string'
import classnames from 'classnames'
import 'whatwg-fetch'
import {deselectItem, selectItem, toggleMoreButton, updateItem} from '../../../actions/contents/page';
import {jsonResponseHandler} from '../../../utils/FetchHelper'
import EntryItemCheckbox from "../../common/EntryItemCheckbox";
import PageListItemButton from "./PageListItemButton";
import * as StatusTypes from "../../../constants/contents/EntryStatusTypes";
import If from "../../common/control/If";
import {addPrefix} from "../../../utils/UriUtil";

@connect(state => ({}), dispatch => ({
    handleSelectItem: (id) => {
        dispatch(selectItem(id))
    },
    handleDeselectItem: (id) => {
        dispatch(deselectItem(id))
    },
    handleUpdateItem: (item) => {
        dispatch(updateItem(item))
    },
    toggleMoreButton: (itemId) => {
        dispatch(toggleMoreButton(itemId))
    },
    dispatch
}))
class PageListItem extends Component {

    constructor(props) {
        super(props);

        this.handleSelect = this.handleSelect.bind(this);
        this.handleHidden = this.handleHidden.bind(this);
        this.handleVisible = this.handleVisible.bind(this);
        this.updateItem = this.updateItem.bind(this);
        this.mouseLeaveHandler = this.mouseLeaveHandler.bind(this);
    }

    handleSelect(e) {
        const {item, handleSelectItem, handleDeselectItem} = this.props;

        if (item.selected) {
            handleDeselectItem(item.id)
        } else {
            handleSelectItem(item.id)
        }

    }

    handleVisible(item) {
        item.processing = true;
        item.visibility = StatusTypes.PUBLIC;
        this.updateItem(item, {visibility: StatusTypes.PUBLIC});
    }

    handleHidden(item) {
        item.processing = true;
        item.visibility = StatusTypes.PRIVATE;
        this.updateItem(item, {visibility: StatusTypes.PRIVATE});
    }

    updateItem(item, changes) {

        const {handleUpdateItem, dispatch} = this.props;

        fetch(addPrefix(`/manage/page/${item.id}/visibility.json`), {
            method: "put",
            credentials: "include",
            headers: {'Content-Type': 'application/x-www-form-urlencoded'},
            body: querystring.stringify(changes)
        })
            .then(jsonResponseHandler(dispatch))
            .then(data => {
                item.processing = false;
                handleUpdateItem(item)
            })
            .catch(r => {
                console.error(r)
                r.json().then(message => {
                    alert(message || "상태를 변경하지 못했습니다.")
                })
            })
    }

    //  Mouse leave 이벤트에 열린 레이어를 닫기위해 toggle값을 -1 default값으로 셋팅한다.
    mouseLeaveHandler(){
        this.props.toggleMoreButton(-1);
    }

    renderTitle(page) {

      const linkUrl = (page.deleting)
        ? "#"
        : "/pages/" + page.slogan;

      return <strong className="tit_post tit_ellip">
        <a href={addPrefix(linkUrl)} title={page.title} className="link_cont" target="_blank">
          <If condition={page.isRestrict}>
            <span className="info_status">[{page.restrictLabel}]</span>
          </If>
          {page.title}
        </a>
        {this.renderHasFile(page)}
      </strong>
    }

    renderHasFile(page) {
        if (page.hasFile) return <span className="ico_blog ico_file"/>
    }

    render() {
        const {item} = this.props;
        const status = item.visibility;

        return (
            <li className={classnames({item_dimmed: item.deleting})} onMouseLeave={this.mouseLeaveHandler}>
                <EntryItemCheckbox item={item} handleSelect={this.handleSelect}/>

                <div className="post_cont">
                    {this.renderTitle(item)}
                    <span className="txt_cate txt_ellip">/{item.slogan}</span>
                    <span className="txt_info txt_ellip">{item.author}</span>
                    <span className="txt_info">{item.published}</span>
                </div>
                <div className="post_btn">

                    {status === StatusTypes.PRIVATE && <span className="ico_blog ico_private">비공개</span>}
                    {status === StatusTypes.PROTECTED && <span className="ico_blog ico_secret">보호</span>}

                    <div className="info_btn">
                        <PageListItemButton item={item}
                                            handleHidden={this.handleHidden}
                                            handleVisible={this.handleVisible}
                        />
                    </div>
                </div>
            </li>
        )
    }

}

export default PageListItem;
